/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Kind_PackInputs */



/**
* | output |
* | --- |
* | "Pack" |
*
* @param {Promo_Kind_PackInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_kind_pack = /** @type {((inputs?: Promo_Kind_PackInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Kind_PackInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lot")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lote")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pacote")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pacchetto")
	return /** @type {LocalizedString} */ ("Pack")
});